/**
 * Context detection for components that are used in several places, e.g. the lesson plan library
 * as a full page and inside a drawer in the agenda. The context is the root component of the
 * current route, as router.getRootComponentName() (see router/index.js) returns it.
 */

// The `name` of the root components (Agenda.vue and LessonPlanLibrary.v2.vue): keep them in sync.
export const AGENDA_ROOT_COMPONENT = 'Agenda';
export const LESSON_PLAN_LIBRARY_ROOT_COMPONENT = 'LessonPlanLibrary';

interface RouterWithRootComponentName {
	getRootComponentName(): string | null;
}

/** Whether the current route is (within) the agenda. */
export function isAgendaRoute(router: RouterWithRootComponentName): boolean {
	return router.getRootComponentName() === AGENDA_ROOT_COMPONENT;
}

/** Whether the current route is (within) the lesson plan library page. */
export function isLessonPlanLibraryRoute(router: RouterWithRootComponentName): boolean {
	return router.getRootComponentName() === LESSON_PLAN_LIBRARY_ROOT_COMPONENT;
}
